import React, { Component } from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Login from "./containers/login/Login";
import "./App.css";
import ForgotPassword from "./containers/forgotpassword/ForgotPassword";
import ResetPassword from "./containers/resetpassword/ResetPassword";
import Registration from "./containers/register/Registration";
import HomeContainer from "./containers/homeContainer/homeContainer";
import Media from "./containers/media/media";
import JoinTeam from "./containers/joinTeam/team";
import CareerNew from "./containers/career/careerNew";
import ContactUs from "./containers/contact/contact";
import ResearchNew from "./containers/researchMaterial/researchNew";
import TestsList from "./containers/testsList/testsList";
import RegisterForm from "./containers/register/RegisterForm";
import * as actions from "./redux/actions/actions";
import PatientHome from "./containers/patient/patientHome";
import CreditPartnerHome from "./containers/creditPartner/creditPartner";
import TraineeHome from "./containers/trainee/traineeHome";
import CheckUser from "./containers/patient/checkUser";
import PatientRequestOTP from "./containers/patient/PatientRequestOTP";
import PatientSignUp from "./containers/patient/patientSignUp";
import PatientLogin from "./containers/patient/patientLogin";
import logout from "./containers/logout/logout";
import TrackSampleTable from "./containers/patient/trackSample/trackSampleTable";
import CoursesOffered from "./containers/trainee/coursesOffered";
import Antibodies from "./containers/testsList/antibodies";
import PatientForgotPassword from "./containers/patient/patientForgotPass";
import PatientResetPassword from "./containers/patient/patientResetPass";
import AdminHome from "./containers/admin/adminHome";
import AdminLogin from "./containers/admin/adminLogin";
import PatientCashReceipt from "./containers/patient/patientcashReceipt";
import PrintButton from "./containers/patient/printButton";
import PatientEditOrder from "./containers/patient/patientEditOrder";
import PatientPaymentForm from "./containers/patient/patientPayForm";
import TrainingAcademy from "./containers/trainee/trainingAcademy";
import AboutCOP from "./containers/aboutCOP/aboutCOP";
import PractiseMap from "./containers/GoogleMap/PractiseMap";

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    let userId = Number(this.props.userTypeId);

    if (this.props.isAuthenticated && userId !== null) {
      if (userId === 1) {
        return (
          <Switch>
            <Route
              path="/creditpartnerHome"
              exact
              component={CreditPartnerHome}
            />
            <Route path="/" exact component={HomeContainer} />
            <Route path="/aboutCOP" exact component={AboutCOP} />
            <Route path="/researchMaterial" component={ResearchNew} />
            <Route path="/media" exact component={Media} />
            <Route path="/testslist" exact component={TestsList} />
            <Route path="/antibodies" exact component={Antibodies} />
            <Route path="/joinTeam" component={JoinTeam} />
            <Route path="/careers" component={CareerNew} />
            <Route path="/contactUs" component={ContactUs} />
            <Route path="/logout" component={logout} />
            <Route path="/courses-offered" component={CoursesOffered} />
            <Route path="/trainingAcademy" component={TrainingAcademy} />
            <Redirect to="/creditpartnerHome" />
          </Switch>
        );
      } else if (userId === 2) {
        return (
          <Switch>
            <Route path="/patientHome" exact component={PatientHome} />
            <Route path="/" exact component={HomeContainer} />
            <Route path="/aboutCOP" exact component={AboutCOP} />
            <Route path="/researchMaterial" component={ResearchNew} />
            <Route path="/media" exact component={Media} />
            <Route path="/testslist" exact component={TestsList} />
            <Route path="/antibodies" exact component={Antibodies} />
            <Route path="/joinTeam" component={JoinTeam} />
            <Route path="/careers" component={CareerNew} />
            <Route path="/contactUs" component={ContactUs} />
            <Route path="/logout" component={logout} />
            <Route
              path="/patientCashReceipt"
              render={props => <PatientCashReceipt {...props} />}
            />
            <Route
              path="/patientInvoice"
              render={props => <PrintButton {...props} />}
            />
            <Route
              path="/patientEditOrder"
              render={props => <PatientEditOrder {...props} />}
            />
            <Route path="/courses-offered" component={CoursesOffered} />
            <Route path="/trainingAcademy" component={TrainingAcademy} />
            <Route path="/patientPayment" component={PatientPaymentForm} />
            <Redirect to="/patientHome" />
          </Switch>
        );
      } else if (userId === 3) {
        return (
          <Switch>
            <Route path="/traineeHome" exact component={TraineeHome} />
            <Route path="/" exact component={HomeContainer} />
            <Route path="/aboutCOP" exact component={AboutCOP} />
            <Route path="/researchMaterial" component={ResearchNew} />
            <Route path="/media" exact component={Media} />
            <Route path="/testslist" exact component={TestsList} />
            <Route path="/antibodies" exact component={Antibodies} />
            <Route path="/joinTeam" component={JoinTeam} />
            <Route path="/careers" component={CareerNew} />
            <Route path="/contactUs" component={ContactUs} />
            <Route path="/logout" component={logout} />
            <Route path="/courses-offered" component={CoursesOffered} />
            <Route path="/trainingAcademy" component={TrainingAcademy} />
            <Redirect to="/traineeHome" />
          </Switch>
        );
      } else if (userId === 4) {
        return (
          <Switch>
            <Route path="/adminHome" exact component={AdminHome} />
            <Route path="/logout" component={logout} />
            <Redirect to="/adminHome" />
          </Switch>
        );
      }
    } else {
      return (
        <Switch>
          <Route path="/" exact component={HomeContainer} />
          <Route path="/aboutCOP" exact component={AboutCOP} />
          <Route path="/joinTeam" component={JoinTeam} />
          <Route path="/researchMaterial" component={ResearchNew} />
          <Route path="/media" exact component={Media} />
          <Route path="/testslist" exact component={TestsList} />
          <Route path="/antibodies" exact component={Antibodies} />
          <Route path="/careers" component={CareerNew} />
          <Route path="/contactUs" component={ContactUs} />
          <Route path="/login" component={Login} />
          <Route path="/register-form" component={RegisterForm} />
          <Route path="/register" component={Registration} />
          <Route path="/check-user" component={CheckUser} />
          <Route path="/request-otp" component={PatientRequestOTP} />
          <Route path="/patient-signup" component={PatientSignUp} />
          <Route path="/patient-login" component={PatientLogin} />
          <Route
            path="/patient-forgotPassword"
            component={PatientForgotPassword}
          />
          <Route
            path="/patient-resetPassword"
            component={PatientResetPassword}
          />
          <Route path="/resetpassword" component={ResetPassword} />
          <Route path="/forgotpassword" component={ForgotPassword} />
          <Route path="/courses-offered" component={CoursesOffered} />
          <Route path="/trainingAcademy" component={TrainingAcademy} />
          <Route path="/admin-login" component={AdminLogin} />
          <Route component={HomeContainer} />
        </Switch>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userTypeId: state.userTypeId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
